module.exports = __webpack_public_path__ + "img/icon_refresh.1f445005.svg";